import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import PlayerCard from '../TeamsPage/PlayerCard';
import { useGolfLeagueContext } from '../context/GolfLeagueContext';
import TeamCardHeader from '../TeamsPage/TeamCardHeader';
import { getRankSuffix } from '../../../utils/GetRankSuffix';
import GolfScoreTable from '../TeamsPage/GolfScoreTable';

const LeaderboardModal = ({ open, onClose, teams, players, events, id, idToSet }) => {
    const { 
        intervalsToShow,
        findTournamentId,
        findTournamentInfo,
    } = useGolfLeagueContext();

    //console.log("Leaderboard Modal", open, teams, players, id, idToSet);
    const selectedPlayer = players?.find(player => player.playerId === id);
    const selectedPlayersTeam = teams?.find(team => team.teamId === selectedPlayer?.teamId);
    const teamLogo = selectedPlayersTeam?.teamLogo;

    const selectedTeam = teams?.find(team => team.teamId === id);
    const teamName = selectedTeam?.teamName;
    const teamOverallRank = selectedTeam?.scores?.overall?.rank;
        const teamOverallScore = selectedTeam?.scores?.overall?.score;
        const teamOverallTied = selectedTeam?.scores?.overall?.tied || false;
        //console.log("Team Tied", teamOverallTied, selectedTeam?.scores?.overall);
        const formattedScore = teamOverallScore === 0 ? "E" : 
                                teamOverallScore > 0 ? `+${teamOverallScore}` : 
                                teamOverallScore;
        const formattedRank = getRankSuffix(teamOverallRank);
    
        const teamRank = `${teamOverallTied ? 'T-' : ''}${formattedRank} Place: (${formattedScore})`;
    const logoUrl = selectedTeam?.teamLogo;

    let teamScores = [];
    if (events && selectedTeam && intervalsToShow) {
        intervalsToShow?.forEach((interval) => {
            const tournamentId = findTournamentId(events, interval);
            const event = events?.find((event) => event.interval === interval);
            const tournamentInfo = findTournamentInfo(selectedTeam, tournamentId);
            //console.log("Tournament Info", tournamentInfo, "Tournament ID", tournamentId, "Interval", interval);
            if (tournamentId) {
                teamScores.push({
                    eventName: event.name,
                    score: tournamentInfo?.score ?? tournamentInfo?.status ?? '-',
                    tied: tournamentInfo?.tied,
                    round1: tournamentInfo?.round1 || tournamentInfo?.status || '-',
                    round2: tournamentInfo?.round2 || tournamentInfo?.status || '-',
                    status: tournamentInfo?.status,
                    rank: tournamentInfo?.rank
                });
            }
        })
    }

    
  // Function to handle the close action of the modal
  const handleClose = () => {
    //console.log("CLOSE!!!");
    onClose?.(); // Call parent-provided close if exists
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="leaderboard-modal-title"
      aria-describedby="leaderboard-modal-description"
    >
      <Box
        sx={{
          backgroundColor: 'white',
          width: '95%',
          maxWidth: '700px',
          margin: '100px auto',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: 24,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {idToSet === 'playerId' && (
            <PlayerCard
                events={events}
                player={selectedPlayer}
                teamLogo={teamLogo}
                playerScoreText={"Overall"}
                showScoresButton={false}
                intervalsToShow={intervalsToShow}
                findTournamentId={findTournamentId}
                findTournamentInfo={findTournamentInfo}
                useTeamLogo={true}
                alwaysShowScores={true}
            />
        )}
        {idToSet === 'teamId' && (
            <>
                <TeamCardHeader 
                    teamName={teamName}
                    teamRank={teamRank}
                    logoUrl={logoUrl}
                />

                <Box sx={{ height: '16px' }}/>

                <GolfScoreTable
                    scores={teamScores}
                />

            </>
        )}

        <Button 
          variant="contained" 
          onClick={handleClose} 
          sx={{ marginTop: 2 }}
        >
          CLOSE
        </Button>
      </Box>
    </Modal>
  );
};

export default LeaderboardModal;
